import type {UseMutationOptions, UseMutationResult} from '@tanstack/react-query';
import {useMutation} from '@tanstack/react-query';
import RequestError from '@errors/RequestError';
import {useLocation, useNavigate} from 'react-router-dom';

export default function useMutationWithAuth<
    TData = never,
    TError = unknown,
    TVariables = void,
    TContext = unknown,
>(
    options: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
    const navigate = useNavigate();
    const location = useLocation();
    return useMutation<TData, TError, TVariables, TContext>({
        ...options,
        onError: (error, variables, context) => {
            if (options.onError) {
                options.onError(error, variables, context);
            }

            if (error instanceof RequestError && error.isAuthorizationError()) {
                navigate('/login', {
                    replace: true,
                    state: {redirectTo: location.pathname},
                });
            }
        },
    });
}
